import type { AdminAppVersionFloors } from "@/types/admin-app-version";

/**
 * Fixture for `GET /admin/app-version` (mock mode).
 *
 * iOS is deliberately SET so mock mode exercises the populated render (min +
 * recommended + store URL + audit trail); android and global are left unset
 * so the same fixture also exercises the "no gate configured" prompt without
 * making every mock-mode session look mis-configured.
 *
 * Like every other mock mutation in this codebase, a mock-mode PUT returns a
 * synthetic echo and does NOT mutate this fixture — a refetch reads the
 * constant back. Mock mode exercises the UI flow, not backend persistence.
 */
export const MOCK_APP_VERSION_FLOORS: AdminAppVersionFloors = {
  floors: [
    {
      platform: "ios",
      minVersion: "1.2.0",
      recommendedVersion: "1.4.0",
      storeUrl: "https://apps.apple.com/app/zone",
      setAt: "2026-06-01T10:00:00Z",
      setByAdminId: "adm_owner_demo",
    },
    {
      platform: "android",
      minVersion: null,
      recommendedVersion: null,
      storeUrl: null,
      setAt: null,
      setByAdminId: null,
    },
    {
      platform: "global",
      minVersion: null,
      recommendedVersion: null,
      storeUrl: null,
      setAt: null,
      setByAdminId: null,
    },
  ],
};
